import { render } from "./DashboardOld.vue?vue&type=template&id=82bd404a&scoped=true"
import script from "./DashboardOld.vue?vue&type=script&lang=js"
export * from "./DashboardOld.vue?vue&type=script&lang=js"

import "./DashboardOld.vue?vue&type=style&index=0&id=82bd404a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82bd404a"]])

export default __exports__